//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowConnect(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.5002 12H16.1102L20.3002 7L16.1102 2H13.5002L16.8602 6H4.00018V8H16.8602L13.5002 12ZM10.5002 12H7.8902L3.7002 17L7.8902 22H10.5002L7.1402 18H20.0002V16H7.1402L10.5002 12Z" fill="currentColor" /></svg>;
}
export default IconArrowConnect;